export const buildGraficosSection = (tipoAccidentePng, tipoGravedadPng) => `
    <div style="display:flex; margin-top:5mm; position:relative;">
      <div style="position:absolute; left:50%; top:56px; bottom:42px; width:1px; background:#d2d2d2; transform:translateX(-0.5px);"></div>
      <div style="flex:1; padding-right:3mm;">
        <div class="chart-title">TIPO DE ACCIDENTE</div>
        <div class="chart-body">
          ${
            tipoAccidentePng
              ? `<img src="${tipoAccidentePng}" alt="Tipo de accidente" style="width:100%;display:block;">`
              : '<div style="min-height:220px;display:flex;align-items:center;justify-content:center;color:#999;">[Gráfico PNG]</div>'
          }
        </div>
        <div class="chart-caption" style="border-top:none;">
          <span>No incluye los siniestros rechazados</span>
          <span>* en cantidades unitarias y porcentuales</span>
        </div>
      </div>
      <div style="flex:1; padding-left:3mm;">
        <div class="chart-title">TIPO DE GRAVEDAD</div>
        <div class="chart-body">
          ${
            tipoGravedadPng
              ? `<img src="${tipoGravedadPng}" alt="Tipo de gravedad" style="width:100%;display:block;">`
              : '<div style="min-height:220px;display:flex;align-items:center;justify-content:center;color:#999;">[Gráfico PNG]</div>'
          }
        </div>
        <div class="chart-caption" style="border-top:none;">
          <span>No incluye los siniestros rechazados ni COVID</span>
          <span>* en cantidades unitarias y porcentuales</span>
        </div>
      </div>
    </div>`
